import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DonationReceiptComponent } from '../donation-receipt/donation-receipt.component';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'equine-ui-nx-donation-receipt-dialog',
  standalone: true,
  imports: [
    CommonModule,
    DonationReceiptComponent,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './donation-receipt-dialog.component.html',
  styleUrl: './donation-receipt-dialog.component.scss',
})
export class DonationReceiptDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<DonationReceiptDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {amount: string, date: string}
  ) {}

  printDonation() {
    this.dialogRef.close('PRINT');
  }

}
